// App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AddJob from './pages/AddJob';
import JobDetails from './pages/JobDetails';
import EditJobWrapper from './pages/EditJob';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import FAQ from './pages/FAQ';
import Services from './pages/Services';
import Contacts from './pages/Contacts';
import { toast } from 'react-toastify';
import './App'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h2>Something went wrong. Try refreshing the page.</h2>;
    }
    return this.props.children;
  }
}

function AppWrapper() {
  const keycloak = window.keycloak;

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      keycloak
        .updateToken(60)
        .catch(() => {
          toast.error('Session expired. Logging out...');
          keycloak.logout({ redirectUri: window.location.origin });
        });
    }, 30000);
    return () => clearInterval(refreshInterval);
  }, [keycloak]);

  return (
    <ErrorBoundary>
      <BrowserRouter>
    <div style={{ margin: 0, padding: 0, maxWidth: '100vw', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>
       <div style={{ margin: 0, padding: 0 }}>
       <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/add" element={<AddJob />} />
          <Route path="/EditJob/:id" element={<EditJobWrapper />} />
          <Route path="/job/:id" element={<JobDetails />} />
          <Route path="about" element={<About />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfUse />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contacts />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
        <Footer />
       </div>
       </div>
      </BrowserRouter>
    </ErrorBoundary>
  );

}
export default AppWrapper;
